/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const GATSBY_PRISMIC_REPOSITORY_NAME =
	process.env.GATSBY_PRISMIC_REPOSITORY_NAME!
if (!GATSBY_PRISMIC_REPOSITORY_NAME) {
	throw new Error("GATSBY_PRISMIC_REPOSITORY_NAME must be defined in .env!")
}
